import { render, staticRenderFns } from "./ClassificationView.vue?vue&type=template&id=7bc14804&scoped=true&"
import script from "./ClassificationView.vue?vue&type=script&lang=js&"
export * from "./ClassificationView.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationView.vue?vue&type=style&index=0&id=7bc14804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc14804",
  null
  
)

export default component.exports